export const reduceFeaturesResponse = ({
  data,
  productLine,
  highlightedProducts,
  state
}) => {
  const newFeatures = Object.assign({}, state.features, {
    [productLine]: data
  });
  const newHighlightedProducts = Object.assign({}, state.highlightedProducts, {
    [productLine]: highlightedProducts
  });
  return {
    features: newFeatures,
    highlightedProducts: newHighlightedProducts
  };
};